const charsWithinParenthesisRegex = /\(([^)]*)\)/gi;
const nonAlphanumericCharsRegex = /[^ A-Za-z0-9]/gi;
const multipleSpacesRegex = /\s+/gi;
export default function getInitial(inputName: string): string {
    let initials = '';
    let name: string = inputName;
    if (!name) {
        return initials;
    }
    name = name.replace(charsWithinParenthesisRegex, ''); // remove chars inside parenthesis
    name = name.replace(nonAlphanumericCharsRegex, ''); // remove non-alphanumeric chars
    name = name.replace(multipleSpacesRegex, ' '); // replace multiple spaces with single
    name = name.trim();
    const partsOfName = name.split(' ');
    if (partsOfName.length) {
        initials += partsOfName[0].charAt(0).toUpperCase();
        initials +=
            partsOfName.length > 1
                ? partsOfName[partsOfName.length - 1].charAt(0).toUpperCase()
                : '';
    }
    return initials;
}
